var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"icp"},[_vm._v(_vm._s(`© ${_setup.year} ${_setup.author} `)),_c('a',{attrs:{"href":"http://beian.miit.gov.cn/","target":"_blank"}},[_vm._v(_vm._s(_setup.record))])])
}
var staticRenderFns = []

export { render, staticRenderFns }